import {Button} from '@/components/ui/button/Button'
import {PrintSiarFormSchema} from '@/features/projects/formSchemas'
import {useStorePrintSiar} from '@/features/projects/queries/useStorePrintSiar'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {useTranslation} from '@/translations/i18n'
import {buildFile} from '@/utilities/helpers'
import {toast} from '@/utilities/toast/toast'
import {useDialogContext} from '@ariakit/react'
import dayjs from 'dayjs'
import {useFormContext, useWatch} from 'react-hook-form'
import RHT from 'react-hot-toast'

export const PrintSiarSubmitButton = ({projectCode}: {projectCode: number}) => {
    const {t} = useTranslation()
    const dialog = useDialogContext()
    const {
        handleSubmit,
        formState: {isValid},
        control
    } = useFormContext<PrintSiarFormSchema>()

    const projectId = useWatch({
        control,
        name: 'projectId'
    })

    const {mutate: onPrint, isPending} = useStorePrintSiar({
        projectId: projectId,
        options: {
            onMutate: () => {
                toast.loading(t('projects:loading_print_siar'), {id: 'print-siar-loading'})
            },
            onSuccess: data => {
                void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECT, projectId]})
                void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, projectId]})
                RHT.dismiss('print-siar-loading')
                const pdfFile = buildFile({
                    extension: 'pdf',
                    fileName: `fm22-${projectCode}-${dayjs().format('DD-MM-YYYY')}`,
                    data
                })
                const pdfUrl = URL.createObjectURL(pdfFile)
                window.open(pdfUrl, '_blank')
            },
            onError: error => {
                RHT.dismiss('print-siar-loading')
                console.error(error)
                toast.error(t('errors:default'))
            }
        }
    })

    const handleClick = handleSubmit(
        data => {
            onPrint({
                addSignature: data.hasSignature,
                printType: data.categorySection
            })
            dialog?.setOpen(false)
        },
        error => {
            console.error(error)
        }
    )

    return (
        <Button variant="primaryNeutral" onClick={handleClick} disabled={!isValid || isPending}>
            {t('commons:print')}
        </Button>
    )
}
